import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Fetch from '../../../../common/components/Fetch';
import ThemedCard from '../ThemedCard';
import LoadingOverlay from '../../../../common/components/LoadingOverlay';
import LoadingView from '../../../../common/components/LoadingView';
import SurveyActions from '../../actions/surveys';

class SurveyCompleted extends React.Component {
  componentDidMount() {
    this.props.actions.surveys.clear();
  }
  render() {
    return (
      <Fetch url="/api/config/pages/surveyCompleted">
        {({ data, pending }) => {
          if (pending) {
            return (
              <div>
                <LoadingView />
                <LoadingOverlay isLoading={pending} />
              </div>
            );
          }
          return (
            <ThemedCard
              {...data}
            />
          );
        }}
      </Fetch>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      surveys: bindActionCreators(SurveyActions, dispatch),
    },
  };
};

export default connect(null, mapDispatchToProps)(SurveyCompleted);



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/SurveyCompleted.js